import React from "react";
import "./styles.css";
import {useTranslation} from "react-i18next";
import first_laptop from "../../../../assets/img/first_laptop.png"
import CustomButton from "../../../../components/CustomButton";

const HeaderSection = () => {
    const [t] = useTranslation("common");
    const downloadWindowsFile = "https://download.splendos.org/splendos/splendos-2023.07.27-x86_64.iso?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=KASKHSAGDAHSJKDUW%24%2F20230808%2F%2Fs3%2Faws4_request&X-Amz-Date=20230808T144127Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=ff39e2ceded54c223812e362f09d5286000bb236a14a66a62921a71cde35c9e7"

    return (
        <div className="homeHeaderSection">
            <div className="buttonsContent" id={"splendos"}>
                <button>
                    {t("common.overview")}
                </button>
                <button>
                    {t("common.grid")}
                </button>
                <button>
                    {t("common.mobile")}
                </button>
                <a href={downloadWindowsFile} download>
                    <button className="download">
                        {t("common.download")}
                    </button>
                </a>
            </div>
            <div className="titleContent wow fadeInUp" data-wow-delay="0.6s">
                <h1>
                    {t("home.headerSection.title")}
                </h1>
                <p>{t("home.headerSection.description")}</p>
                <div className="buttonsContent">
                    <CustomButton keyTranslate={"common.learnMore"} />
                    <CustomButton keyTranslate={"common.orderNow"} />
                </div>
            </div>
            <img className="first_laptop wow fadeInUp" data-wow-delay="0.8s" src={first_laptop} alt={"first_laptop"}/>
        </div>
    );
}

export default HeaderSection;
